import { IStaticClassName, IInitializableWithStaticClassName } from "./Initializable";

export abstract class Block<T extends IStaticClassName, DatasetKeys extends string = string> implements IInitializableWithStaticClassName<T> {
    /**
     * Typed dataset of the root element
     */
    protected readonly dataset: {
        [K in DatasetKeys]: string | undefined;
    };

    constructor(
        protected readonly rootElement: HTMLElement,
        protected readonly index: number
    ) {
        this.dataset = (rootElement.dataset as {
            [K in DatasetKeys]: string | undefined;
        });
    }

    getRootElement(): HTMLElement {
        return this.rootElement;
    }

    init() {};
    destroy() { };
}
